export default class MultiTrackAudioPlayer {
    tracks: MediaStreamTrack[] = [];
    audio: HTMLAudioElement;
    isPlaying = false;
  
    constructor() {
        this.audio = new Audio();
    }
  
    addTrack(track: MediaStreamTrack) {
        this.tracks.push(track);
        this.play();
      }
    
      removeTrack(track: MediaStreamTrack) {
        this.tracks = this.tracks.filter(t => t !== track);
        this.play(); 
      }
  
    play() {
        const stream = new MediaStream(this.tracks);
        this.audio.srcObject = stream;
    
        this.audio.onplay = () => {
          this.isPlaying = true;
        }
    
        this.audio.onpause = () => {
          this.isPlaying = false;
        }
    
        this.audio.onended = () => {
          this.isPlaying = false;
        }
    
        this.audio.play().catch(err => {
          // 处理错误
          console.error(`[MultiTrackPlayer] play err=${err}`);
        });
      }

      pause() {
        if (!this.isPlaying) return;
        
        this.audio.pause();
      }


}